/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamExamidLangs200,
  GetApiV1ExamExamidLangs401,
  GetApiV1ExamExamidLangs404,
  GetApiV1ExamExamidLangs500,
  GetApiV1ExamExamidLangsPathParams,
  GetApiV1ExamExamidLangsQueryParams,
  GetApiV1ExamExamidLangsQueryResponse,
} from "../../types/examEvaluationController/GetApiV1ExamExamidLangs.ts";
import { examLangListItemViewModelSchema } from "../examLangListItemViewModelSchema.ts";

export const getApiV1ExamExamidLangsPathParamsSchema = z.object({
  examId: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1ExamExamidLangsPathParams>;

export const getApiV1ExamExamidLangsQueryParamsSchema = z.object({
  pageNumber: z.coerce.number().int().default(1),
  pageSize: z.coerce.number().int().default(20),
}) as unknown as ToZod<GetApiV1ExamExamidLangsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamExamidLangs200Schema = z.array(
  z.lazy(() => examLangListItemViewModelSchema),
) as unknown as ToZod<GetApiV1ExamExamidLangs200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamExamidLangs401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamExamidLangs401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ExamExamidLangs404Schema =
  z.any() as unknown as ToZod<GetApiV1ExamExamidLangs404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamExamidLangs500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamExamidLangs500>;

export const getApiV1ExamExamidLangsQueryResponseSchema = z.lazy(
  () => getApiV1ExamExamidLangs200Schema,
) as unknown as ToZod<GetApiV1ExamExamidLangsQueryResponse>;
